import api from '../lib/api';
import type {
  CampaignFollow,
  CampaignFollowFilters,
  CreateCampaignFollowRequest,
  UpdateCampaignFollowRequest,
  ToggleCampaignFollowRequest
} from '../types/campaignFollow';
import type { PaginatedResponse } from '../types/api';

export const campaignFollowService = {
  getAll: async (
    page = 1,
    limit = 20,
    filters: CampaignFollowFilters = {}
  ): Promise<PaginatedResponse<CampaignFollow>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (filters.campaign_id) params.append('campaign_id', filters.campaign_id.toString());
    if (filters.stage) params.append('stage', filters.stage);
    if (filters.is_active !== undefined) params.append('is_active', filters.is_active.toString());
    if (filters.new_stage) params.append('new_stage', filters.new_stage);
    if (filters.new_action) params.append('new_action', filters.new_action);

    const response = await api.get(`/mkt-campaign-follow?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<CampaignFollow> => {
    const response = await api.get(`/mkt-campaign-follow/${id}`);
    return response.data;
  },

  create: async (data: CreateCampaignFollowRequest): Promise<CampaignFollow> => {
    const response = await api.post('/mkt-campaign-follow', data);
    return response.data;
  },

  update: async (id: number, data: UpdateCampaignFollowRequest): Promise<CampaignFollow> => {
    const response = await api.put(`/mkt-campaign-follow/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/mkt-campaign-follow/${id}`);
  },

  toggleActive: async (id: number, data: ToggleCampaignFollowRequest): Promise<CampaignFollow> => {
    const response = await api.patch(`/mkt-campaign-follow/${id}/toggle`, data);
    return response.data;
  },
};
